module.exports = __webpack_public_path__ + "img/2.817f48b8.png";